import { CrumpetCorner, CrumpetId } from '../../model/components/CrumpetCorner';
import { ColorInput } from './ColorInput';
import { hexToUnityColor, UnityColor } from '@lifeserver/shared';

const CRUMPET_OPTIONS: Array<{
    value: CrumpetCorner['crumpetId'] | '';
    label: string;
}> = [
    { value: '', label: 'No Corner' },
    { value: 'NoCrumpet', label: 'No Crumpet' },
    { value: 'Puppet', label: 'Puppet' },
    { value: 'Petalette', label: 'Petalette' },
    { value: 'Spapet', label: 'Spapet' },
    { value: 'Sherpet', label: 'Sherpet' },
];

const ALLOWED_COLORS: UnityColor[] = (
    ['#84BBE9', '#FFDC96', '#6CCD97', '#AEC3FF', '#FFB7A1'] as const
).map(hexToUnityColor);

const DEFAULT_BACKGROUND_COLOR: UnityColor = ALLOWED_COLORS[0];
const DEFAULT_CRUMPET_ID: CrumpetId = 'NoCrumpet';

export interface CrumpetCornerInputProps {
    value?: CrumpetCorner;
    onChange?: (value?: CrumpetCorner) => void;
}

export const CrumpetCornerInput = ({
    value,
    onChange,
}: CrumpetCornerInputProps) => {
    const onCrumpetChange = (crumpetId?: CrumpetId) => {
        onChange?.(
            crumpetId
                ? {
                      ...value,
                      crumpetId,
                      foldColor:
                          value === undefined
                              ? DEFAULT_BACKGROUND_COLOR
                              : value.foldColor,
                  }
                : undefined,
        );
    };

    const onColorChange = (foldColor: UnityColor) => {
        onChange?.({
            foldColor,
            crumpetId:
                value === undefined ? DEFAULT_CRUMPET_ID : value.crumpetId,
        });
    };

    return (
        <div>
            <select
                value={value?.crumpetId ?? ''}
                onChange={(e) =>
                    onCrumpetChange(
                        e.target.value === ''
                            ? undefined
                            : (e.target.value as CrumpetId),
                    )
                }
            >
                {CRUMPET_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>

            {value && (
                <fieldset>
                    <legend>Fold Color</legend>
                    <ColorInput
                        value={value?.foldColor}
                        onChange={(color) => onColorChange(color)}
                        allowedColors={ALLOWED_COLORS}
                    />
                </fieldset>
            )}
        </div>
    );
};
